export enum AudioMode {
    NO_AUDIO = "no_audio",
    SELECTABLE_AUDIO = "selectable"
};

export enum PlayMode {
    LOOP = "loop",
    SINGLE_PLAY = "single"
};



export interface MediaPlayOptions {
    audioMode: AudioMode,
    playMode: PlayMode,
    timeCutSeconds?: number
}



export const DefaultVideoPlayOptions: MediaPlayOptions = {
    audioMode: AudioMode.SELECTABLE_AUDIO,
    playMode: PlayMode.LOOP,
    timeCutSeconds: -1
};